export default __webpack_public_path__ + "static/media/download.645f7601.jpeg";